import BigNumber from 'bignumber.js'
import Modal from 'components/Modal'
import Text from 'components/Text'
import TokenInput from 'components/TokenInput/TokenInput'
import React, { useCallback, useMemo, useState } from 'react'
import styled from 'styled-components/macro'

import { BorderButton } from '../index'
import * as Styles from '../styles'

export const getFullDisplayBalance = (balance: BigNumber) => {
  return balance.toString()
}

interface DepositModalProps {
  isOpen: boolean
  max: BigNumber
  onConfirm: (amount: string) => void
  onDismiss: () => void
  tokenName?: string
}

const Image = styled.img`
  width: 24px;
  height: 24px;
  cursor: pointer;
`

const Header = styled.div`
  padding: 28px 24px;
  border-bottom: 1px solid rgba(115, 126, 141, 0.16);
  width: 100%;
`

const Container = styled.div`
  margin: 24px;
`

const StyledErrorMessage = styled(Text)`
  position: relative;
  margin-top: 10px;
  padding-left: 10px;
  color: #f5455b;
  a {
    display: inline;
  }
`

const DepositModal: React.FC<DepositModalProps> = ({ isOpen, max, onConfirm, onDismiss, tokenName = 'MJT' }) => {
  const [val, setVal] = useState('')
  const [pendingTx, setPendingTx] = useState(false)

  const fullBalance = useMemo(() => {
    return getFullDisplayBalance(max)
  }, [max])

  const handleChange = useCallback(
    (e: React.FormEvent<HTMLInputElement>) => {
      setVal(e.currentTarget.value)
    },
    [setVal]
  )

  const handleSelectMax = useCallback(() => {
    setVal(fullBalance)
  }, [fullBalance, setVal])

  const isValidAmmount = React.useMemo(() => {
    if (new BigNumber(val).gt(fullBalance)) {
      return false
    }
    return true
  }, [val, fullBalance])

  return (
    <Modal isOpen={isOpen}>
      <div style={{ width: '100%' }}>
        <Header>
          <Styles.Flex justify="space-between">
            <Text fontSize="20px" bold>
              Deposit MJT Tokens
            </Text>
            <Image src={require('../imgs/close.svg').default} onClick={onDismiss} />
          </Styles.Flex>
        </Header>
        <Container>
          <TokenInput
            value={val}
            onSelectMax={handleSelectMax}
            onChange={handleChange}
            max={fullBalance}
            symbol={tokenName}
          />
          {!isValidAmmount && <StyledErrorMessage fontSize="14px">* Insufficient balance</StyledErrorMessage>}
          <Styles.Flex justify="space-between" margin="30px 0 0">
            <BorderButton style={{ width: '142px', height: '48px' }} onClick={onDismiss}>
              Cancel
            </BorderButton>
            <BorderButton
              style={{ width: '142px', height: '48px' }}
              disabled={
                pendingTx || fullBalance === '0' || val === '0' || !val || !isValidAmmount || new BigNumber(val).lte(0)
              }
              onClick={async () => {
                setPendingTx(true)
                try {
                  await onConfirm(val)
                  onDismiss()
                } finally {
                  setPendingTx(false)
                }
              }}
            >
              {pendingTx ? <span>Pending ...</span> : 'Confirm'}
            </BorderButton>
          </Styles.Flex>
        </Container>
      </div>
    </Modal>
  )
}

export default DepositModal
